import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDrawOwed } from '../Deck/selectors';
import { draw } from '../Deck/actions';
import { Button } from '../Controls';

/**
 * Every turn starts by drawing a card; there is nothing to undo, so it does not ask first. Dragging the deck onto
 * the hand draws too (Deck).
 */
const DrawButton = ({ userId }) => {
  const dispatch = useDispatch();
  const owed = useSelector((state) => selectDrawOwed(state, { userId }));

  if (!owed) {
    return null;
  }

  // Waiting on the opponent's new active Pokémon, for one; the banner says why.
  return <Button $primary onClick={() => dispatch(draw())} disabled={owed.drawing || !!owed.reason}>Draw a card</Button>;
};

DrawButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default DrawButton;
